import * as R from 'ramda'
import upperFirst from 'lodash/fp/upperFirst'

export function find_by_id(models) {
    return R.compose(

        // ggf. Default-Wert zurueckgeben
        R.defaultTo({}),

        // Nach Adress mit ID suchen
        id => R.find(R.propEq('id', id), models)
    )
}

export function find_default_address(type) {
    const property = `isDefault${upperFirst(type)}Address`

    return R.compose(
        // ggf. leeres Default-Objekt setuen
        R.defaultTo({}),

        // Nach Default-Adresse suchen
        R.find(R.propEq(property, true))
    )
}

export function find_default_billing_address(models) {
    return find_default_address('billing')(models)
}

export function find_default_correspondence_address(models) {
    return find_default_address('correspondence')(models)
}

export function find_default_shipping_address(models) {
    return find_default_address('shipping')(models)
}

export function format_name_by_default_address(type) {
    const property = `isDefault${upperFirst(type)}Address`

    return model => {
        if (model[property]) {
            return { ...model, name: `${model.name} (Standardadresse)` }
        }

        return model
    }
}

export function format_name_by_default_billing_address(model) {
    return format_name_by_default_address('billing')(model)
}

export function format_name_by_default_correspondence_address(model) {
    return format_name_by_default_address('correspondence')(model)
}

export function format_name_by_default_shipping_address(model) {
    return format_name_by_default_address('shipping')(model)
}

export function sort_by_is_default_billing_address(models) {
    return R.sortBy(model => !model.isDefaultBillingAddress, models)
}

export function sort_by_is_default_correspondence_address(models) {
    return R.sortBy(model => !model.isDefaultCorrespondenceAddress, models)
}

export function sort_by_is_default_shipping_address(models) {
    return R.sortBy(model => !model.isDefaultShippingAddress, models)
}


